module.exports = __webpack_public_path__ + "static/media/flowers.63e5598b.png";